export enum IColor {
  green = "green",
  orange = "orange",
  violet = "violet",
  red = "red",
  blue = "blue",
  pink = "pink",
  purple = "purple",
  babyBlue = "babyBlue",
  yellow = "yellow",
  loading = "loading",
  disapproved = "disapproved",
  waiting = "waiting",
  success = "success",
  incolor = "incolor",
  instruments = "instruments",
  copom = "copom",
}

export interface ITypeColor {
  color: string;
  bg: string;
  borderColor?: string;
  text?: string;
}

export const variantColors: Record<IColor, ITypeColor> = {
  green: { bg: "#E9F8EB", color: "#23BD32" },
  violet: { bg: "#EAE8F1", color: "#2C1B73" },
  red: { bg: "#FCE8EB", color: "#E3183B" },
  blue: { bg: "#ECF3FE", color: "#1B4FDF" },
  pink: { bg: "#FDEDFD", color: "#EB49EE" },
  purple: { bg: "#F2EAFC", color: "#8131E6" },
  babyBlue: { bg: "#EAF5FC", color: "#319CE6" },
  orange: { bg: "#FFEEDE", color: "#FB6815", borderColor: "#bd4500" },
  yellow: { bg: "#FEF7EB", color: "#FAAB36" },
  loading: {
    bg: "#FEF7EB",
    color: "#FAAB36",
    borderColor: "#f29100",
    text: "global.variant_color.in_processing",
  },
  disapproved: {
    bg: "#FEEBEB",
    color: "#F43333",
    borderColor: "#f80000",
    text: "global.variant_color.rejected",
  },
  waiting: {
    bg: "#F0F0F0",
    color: "#B2B1B1",
    borderColor: "#B2B1B1",
    text: "global.variant_color.waiting",
  },
  success: {
    bg: "#E9F8EB",
    color: "#23BD32",
    borderColor: "#169C3C",
    text: "global.variant_color.approved",
  },
  incolor: {
    bg: "transparent",
    color: "#EAF5FC",
    borderColor: "#EAF5FC",
    text: "global.variant_color.waiting",
  },
  instruments: { bg: "white", color: "#319CE6" },
  copom: { bg: "#EAF0FC", color: "#5E71D7" },
};
